module.exports = __webpack_public_path__ + "img/logo_footer.35482a5e.png";